export var HighFrequencyBackupScheduleFrequency;
(function (HighFrequencyBackupScheduleFrequency) {
    HighFrequencyBackupScheduleFrequency["HIGH_FREQUENCY_BACKUP_SCHEDULE_INTERVAL"] = "INTERVAL";
    HighFrequencyBackupScheduleFrequency["HIGH_FREQUENCY_BACKUP_SCHEDULE_DAILY"] = "DAILY";
    HighFrequencyBackupScheduleFrequency["HIGH_FREQUENCY_BACKUP_SCHEDULE_WEEKLY"] = "WEEKLY";
    HighFrequencyBackupScheduleFrequency["HIGH_FREQUENCY_BACKUP_SCHEDULE_MONTHLY"] = "MONTHLY";
    HighFrequencyBackupScheduleFrequency["HIGH_FREQUENCY_BACKUP_SCHEDULE_ANNUALLY"] = "ANNUALLY";
    HighFrequencyBackupScheduleFrequency["HIGH_FREQUENCY_BACKUP_SCHEDULE_UNSPECIFIED"] = "UNSPECIFIED";
})(HighFrequencyBackupScheduleFrequency || (HighFrequencyBackupScheduleFrequency = {}));
